import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import NavbarDesktop from "./NavbarDesktop";
import NavbarMobile from "./NavbarMobile/NavbarMobile";

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return isMobile ? <NavbarMobile /> : <NavbarDesktop />;
};

export default Navbar;
